import { API_ENDPOINTS } from "@/api/services/profile/apiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const basicDetailsApi = baseApi.injectEndpoints({
 
  endpoints: (builder) => ({
    fetchBasicDetails: builder.query({
      query: () => ({
        url: API_ENDPOINTS.BASIC_DETAILS.FETCH_BASIC_DETAILS,
        method: "GET",
      }),
      providesTags: [{ type: "basicDetails", id: "LIST" }],
    }),

    putBasicDetails: builder.mutation({
      query: (formData) => ({
        url: API_ENDPOINTS.BASIC_DETAILS.EDIT_BASIC_DETAILS,
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: [{ type: "basicDetails", id: "LIST" }],
    }),

    // api for HR
    hrFetchBasicDetails: builder.query({
      query: (empId) => ({
        url: API_ENDPOINTS.BASIC_DETAILS.HR_FETCH_BASIC_DETAILS(empId),
        method: "GET",
      }),
      providesTags: [{ type: "hrBasicDetails", id: "LIST" }],
    }),

    hrPutBasicDetails: builder.mutation({
      query: ({ formData, empId }) => ({
        url: API_ENDPOINTS.BASIC_DETAILS.HR_EDIT_BASIC_DETAILS(empId),
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: [{ type: "hrBasicDetails", id: "LIST" }, { type: "basicDetails", id: "LIST" }, { type: "profileDetails", id: "LIST" }, { type: "hrProfileDetails", id: "LIST" }],
    }),
  }),
});

export const {
  useFetchBasicDetailsQuery,
  usePutBasicDetailsMutation,
  useHrFetchBasicDetailsQuery,
  useHrPutBasicDetailsMutation,
} = basicDetailsApi;
